import React from 'react';
import './MessageInfoEnvoi.scss'

export default function MessageInfoEnvoi(
    {
        isSuccess,
        message,
        display,
    }
) {

    const MESSAGES = window?.confPub?.UI?.FORMULAIRES?.MESSAGES

    return (
        <>
            { display && (
                <>
                    { isSuccess ? (
                            <div className={ 'success-window' }>
                                { message ? message : MESSAGES?.SUCCES_DEMANDE }
                            </div>
                        )
                        :
                        (
                            <div className={ 'error-window' }>
                                { message ? message : MESSAGES?.ECHEC_DEMANDE }
                            </div>
                        )
                    }
                </>
            )}

        </>
    )
}